import { defineStore } from 'pinia'
import { ref } from 'vue'
import useCrudStore from '@/hooks/useCrudStore'

import {
  fetchItems,
  searchSpots,
  checkSuitableCampaigns
} from '@/apps/traforama/api/spots'
import { ISpotsPayload, ISpotsFilter } from '@/apps/traforama/interfaces/spots'

const defaultFilter: ISpotsFilter = {}

export const useSpotsStore = defineStore('spots', () => {
  const suitableCampaigns = ref<{ [itemId: string]: Array<any> }>({})

  const {
    FetchItems,
    itemById,
    items,
    currentItems,
    sorted,
    currentSorted,
    listLoading
  } = useCrudStore({
    defaultFilter,
    fetchItems
  })

  const SearchItems = async (payload: ISpotsPayload) => {
    const response = await searchSpots(payload)
    return response.data
  }

  const CheckSuitableCampaigns = async (id: string) => {
    listLoading.value = true
    const response = await checkSuitableCampaigns(id)
    listLoading.value = false
    setSuitableCampaigns(id, response.data)
    return response.data
  }

  const setSuitableCampaigns = (id: string, campaigns: Array<any>) => {
    suitableCampaigns.value[id] = campaigns
  }

  return {
    items,
    currentItems,
    currentSorted,
    suitableCampaigns,

    FetchItems,
    SearchItems,
    CheckSuitableCampaigns,

    sorted
  }
})
